module.exports = __webpack_public_path__ + "img/a3.dac20ca8.jpeg";